import React, {useEffect, useState} from "react";
import {loadUsers} from "../user/usersAction";
import {patchProject} from "../project/one-project/projectAction";
import {useDispatch, useSelector} from "react-redux";
import add from '../../images/add_circle.svg';
import cancel from '../../images/action_buttons/cancel_black.svg'
import {v4 as uuidv4} from 'uuid';
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import SearchBarUserName from "../search-bar/SearchBarUserName";
import useFilterUser from "../../custom-hooks/useFilterUser";
import accountSVG from "../../images/account.svg";
import {FunctionalModal} from "./FunctionalModal";
import {getImage} from "../../utils/utils";


const AddMemberInProject = ({setOpenModal}) => {

    const dispatch = useDispatch();
    const {id, members, pilot, copilot} = useSelector(state => state.project)
    const [usersNotInProject, setUsersNotInProject] = useState([])

    useEffect(() => {
        dispatch(loadUsers());
    }, [dispatch])

    const {users} = useSelector(state => state.users);

    const addNewMemberToTheTeam = async (memberId) => {
        let newMember = {"members": [{"memberId": memberId}]}
        await dispatch(patchProject(id, newMember))
    }

    useEffect(() => {
        let membersIds = members.map(m => m.id)
        let usersIds = users.map(u => u.id)
        let usersWithoutMembersIds = usersIds.filter(val => !membersIds.includes(val))
        let finalArray = []
        users.forEach((user) => {
            if (usersWithoutMembersIds.includes(user.id)) {
                if((user.id !== pilot.id) && (user.id !== copilot?.id)){
                    finalArray.push(user)
                }
            }
        })
        setUsersNotInProject(finalArray)
    }, [members, users]);


    const closeUpdate = () => {
        setOpenModal(false);
    }

    const {
        query,
        setQuery,
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace
    } = useFilterUser(usersNotInProject)

    const displayModal = () => {
        return (
            <Container>
                <div>
                    <h1> Ajouter un membre </h1>
                    <img
                        className='close-svg'
                        src={cancel}
                        alt={"fermer la fenêtre"}
                        onClick={closeUpdate}
                    />
                </div>
                <Wrapper>
                    <SearchBarUserName
                        name={"membre"}
                        setQuery={setQuery}
                    />
                    {usersNotInProject
                        .filter(u =>
                            u.firstName.toLowerCase().includes(query.toLowerCase()) ||
                            u.lastName.toLowerCase().includes(query.toLowerCase()) ||
                            getFullNameNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query)) ||
                            getFullNameInverseNoWhiteSpace(u).includes(getQueryNoWhiteSpace(query))
                        )
                        .map((user) => (
                            <User key={uuidv4()}>
                                <img
                                    src={getImage(user.photo, accountSVG)}
                                    alt={`profil de ${user.firstName} ${user.lastName}`}
                                />
                                <Name>
                                    {user.firstName} {user.lastName}
                                </Name>
                                <label>
                                    <input
                                        type="radio"
                                        name="members"
                                        value={user.id}
                                        onClick={() => addNewMemberToTheTeam(user.id)}
                                    />
                                    <img
                                        src={add}
                                        alt="ajouter un membre"
                                    />
                                </label>
                            </User>
                        ))}
                </Wrapper>
            </Container>
        )

    }
    return (
        <FunctionalModal
            setOpen={setOpenModal}
            component={displayModal()}
        />
    )
}

const Container = styled(BaseModal)`
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;

  h1 {
    margin-top: 1em;
  }

  .close-svg {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    cursor: pointer;
  }

  @media (min-width: 600px) {
    width: 450px;


  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  align-items: center;
  margin-top: 1em;
  overflow-y: auto;
  flex-grow: 1;
  @media (min-width: 600px) {
    margin-bottom: 1em;
  }
`
const User = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(166, 172, 181, 0.6);
  padding: 0.5em;

  p {
    margin-left: 1em;
    flex-grow: 1;
  }

  &:hover {
    border-radius: 5px;
    background-color: rgba(166, 172, 181, 0.3)
  }

  img:first-child {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
  }

  label > input {
    opacity: 0;
    position: relative;
  }

  label > input + img {
    cursor: pointer;
  }
`

const Name = styled.p`
  white-space: break-spaces;
  width: 60%;
`
export default AddMemberInProject;